import { render, staticRenderFns } from "./bindingLog.vue?vue&type=template&id=849b846c&scoped=true"
import script from "./bindingLog.vue?vue&type=script&lang=js"
export * from "./bindingLog.vue?vue&type=script&lang=js"
import style0 from "./bindingLog.vue?vue&type=style&index=0&id=849b846c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849b846c",
  null
  
)

export default component.exports